'use client';

import theme from '@/components/core/theme';
import { css } from '@linaria/core';

export const root = css`
  display: grid;
  max-width: 800px;
  margin: auto;
  grid-template-columns: 1fr;
  gap: 0.5rem;
  background-image: ${theme.gradients.blue};
  border-radius: 0.5rem;
  color: white;
  margin-top: var(--image-overflow);
  text-align: center;
  --image-overflow: 32px;

  @media screen and (width > ${theme.sizes.screens.md}) {
    text-align: left;
    grid-template-columns: 1fr 0.65fr;
    --image-overflow: 100px;
  }
`;

export const image = css`
  width: 100%;
  margin-top: calc(var(--image-overflow, 0) * -1);
  display: flex;
  justify-content: center;
`;

export const text = css``;

export const title = css`
  font-size: 24px;
  font-weight: 700;
`;

export const content = css`
  padding: 1rem 2rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  justify-content: center;
  align-items: center;
  @media screen and (width > ${theme.sizes.screens.md}) {
    align-items: flex-start;
  }
`;

export const button = css`
  color: ${theme.colors.primary[1]};
`;
